import apiClient from '../client';
const ENDPOINT = '/enrollments';

export const enrollmentsApi = {
    delete: (id) => apiClient.delete(`${ENDPOINT}/${id}`)
};
